import { createContext, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const INVITE_KEY = "bl_invite";

export const login = (inviteToken) => {
  if (typeof inviteToken === "string") {
    localStorage.setItem(INVITE_KEY, inviteToken);
    localStorage.setItem("bl_src", new URLSearchParams(window.location.search).get("s") || "");
  }
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const AuthProvider = ({ children }) => {
  const qc = useQueryClient();
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    // Returning from OAuth: AuthCallback establishes the session first
    if (window.location.hash?.includes("session_id=")) return;
    api.me().then(setUser).catch(() => setUser(null));
  }, []);

  const logout = async () => {
    await api.logout().catch(() => null);
    qc.clear();
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
